import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  makeStyles,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { SyntheticEvent } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    width: 437,
    textAlign: 'right',
    '& button': {
      padding: 24,
    },
    '@media(max-width: 420px)': {
      width: 300,
      '& button': {
        paddingBottom: 0,
      },
    },
  },
  dialogContent: {
    padding: '16px 24px',
  },
  dialogContentText: {
    fontSize: 15,
    '& p': {
      color: theme.palette.grey[600],
      fontWeight: 600,
      margin: '16px 0px',
      textAlign: 'left',
    },
  },
  dialogActions: {
    padding: '0 24px 24px 24px',
    '& button': {
      fontSize: 14,
      fontWeight: 600,
      padding: '9.5px 16px',
      textTransform: 'none',
      '@media(max-width: 420px)': {
        fontSize: 10,
      },
    },
  },
}));

interface IProps {
  openRenewalModal: boolean;
  handleCloseCancel: () => void;
  openRenewal: (event: SyntheticEvent) => void;
}

const ConfirmPurchaseModal = ({ openRenewalModal, handleCloseCancel, openRenewal }: IProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={openRenewalModal}
      onClose={handleCloseCancel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <div className={classes.container}>
        <IconButton aria-label='close' onClick={handleCloseCancel}>
          <CloseIcon />
        </IconButton>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText className={classes.dialogContentText}>
            <p>Tem certeza que deseja comprar essa renovação?</p>
            <p>Se você já realizou uma compra, aguarde a entrega por até 24h.</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleCloseCancel}>Cancelar</Button>
          <Button variant='contained' color='primary' onClick={openRenewal}>
            Quero renovar!
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ConfirmPurchaseModal;
